import designTokens from "@vygruppen/spor-design-tokens";
import {
  createSystem,
  defineConfig,
  mergeConfigs,
  themes,
} from "@vygruppen/spor-react";

const overrideConfig = defineConfig({
  globalCss: {
    "html .maplibregl-popup-content": {
      background: "icon.highlight !important",
      borderRadius: `${designTokens.size["border-radius"].sm} !important`,
      color: "text.brand",
    },
    "html .maplibregl-popup-tip": {
      borderTopColor: "icon.highlight !important",
    },
  },
});

export const vyTeknologiTheme = createSystem(
  mergeConfigs(themes.VyTeknologi._config, overrideConfig),
);
